import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import TrackingResult from "./trackingResult";
import { filterTracking } from "../../helpers/tracking";

export default function TabComponent(props) {
  const tabs = [
    ["semua", "Semua"],
    ["disimpan", "Disimpan"],
    ["menunggu", "Menjemput"],
    ["perjalanan", "Delivery"],
    ["selesai", "Selesai"],
    ["retur", "Retur"],
    ["lainnya", "Lainnya"],
  ];
  return (
    <Tabs defaultActiveKey="semua" id="uncontrolled-tab-example">
      {tabs.map((tab, i) => {
        const filteredData = filterTracking(props.tracking, tab[0]);
        let title = tab[1];
        if (filteredData.length > 0) title += ` (${filteredData.length})`;

        return (
          <Tab eventKey={tab[0]} title={title} tabClassName="px-2 py-1" key={i}>
            <div className="mt-4">
              {filteredData.map((data, idx) => (
                <div className="mb-2" key={idx}>
                  <TrackingResult
                    data={data}
                    resultIndex={idx}
                    onClickCourier={props.onClickCourier}
                    courierList={props.courierList}
                  />
                </div>
              ))}

              {filteredData.length < 1 && (
                <div className="w-100 text-center my-md">
                  <h5 className="text-violet-600">Tidak ada pengiriman dalam status ini</h5>
                </div>
              )}
            </div>
          </Tab>
        );
      })}
    </Tabs>
  );
}
